import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import "../DestinationOffer/DestinationDetails.css";
import { Link } from "react-router-dom";
import WhyChoose from "../WhyChoose/WhyChoose";
import {
  FaClock,
  FaPlane,
  FaPassport,
  FaCity,
  FaUsers,
  FaMoneyBillAlt,
  FaArrowRight,
  FaStar,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaCheck,
  FaChevronDown,
  FaChevronUp,
  FaHotel,
  FaUmbrellaBeach,
  FaCar,
  FaSwimmingPool,
  FaWifi,
  FaUtensils,
} from "react-icons/fa";

import Deal from "../Deal/Deal";

const destinations = [
  {
    id: "turkey",
    image: "/turkey.webp",
    location: "Turkish Riviera & Cappadocia",
    nights: 7,
    price: 699,
    description:
      "Uncover the enchanting terrain of Cappadocia and the gorgeous shores of the Turkish Riviera. Investigate distinctive rock structures, enjoy a balloon flight, and unwind on exquisite Mediterranean coasts. Encounter an ideal mixture of natural marvels, deep heritage, and Turkish warmth.",
    highlights: [
      "Sunrise balloon flight above Cappadocia's unique formations",
      "Discover historic subterranean settlements",
      "Unwind on Antalya's brilliant blue shores",
      "Explore historical locations such as Ephesus",
      "Sample classic Turkish dishes and bath rituals",
      "Cruise the magnificent Turquoise Coastline",
      "See the amazing thermal springs of Pamukkale",
    ],
    facts: [
      { icon: <FaClock />, label: "Time Zone", value: "GMT+3" },
      {
        icon: <FaPlane />,
        label: "Approximate Flight Duration",
        value: "4 hours",
      },
      { icon: <FaPassport />, label: "Visa Needed", value: "Yes (e-Visa)" },
      { icon: <FaCity />, label: "Capital", value: "Ankara" },
      { icon: <FaUsers />, label: "Inhabitants", value: "84 million" },
      { icon: <FaMoneyBillAlt />, label: "Money", value: "Turkish Lira" },
    ],
  },
  {
    id: "morocco",
    image: "/morocco.webp",
    location: "Morocco's Magic: Coast & Sahara",
    nights: 9,
    price: 899,
    description:
      "Begin a remarkable voyage across Morocco's varied scenery. From the lively markets of Marrakech to the boundless Sahara and the lovely Atlantic shoreline, discover a country of colorful traditions, age-old customs, and spectacular views.",
    highlights: [
      "Camel journey through the Sahara sands",
      "Tour the azure town of Chefchaouen",
      "See the ancient markets of Fez and Marrakech",
      "Spend a night at a desert Berber encampment",
      "Take part in Moroccan culinary workshops",
      "Walk the beautiful Atlas Mountain paths",
      "Tour the renowned kasbah of Ait Benhaddou",
    ],
    facts: [
      { icon: <FaClock />, label: "Time Zone", value: "GMT+1" },
      {
        icon: <FaPlane />,
        label: "Approximate Flight Duration",
        value: "3 hours 30 minutes",
      },
      {
        icon: <FaPassport />,
        label: "Visa Needed",
        value: "No (for many visitors)",
      },
      { icon: <FaCity />, label: "Capital", value: "Rabat" },
      { icon: <FaUsers />, label: "Inhabitants", value: "37 million" },
      { icon: <FaMoneyBillAlt />, label: "Money", value: "Moroccan Dirham" },
    ],
  },
  {
    id: "dubai",
    image: "/dubai.webp",
    location: "Luxury Escape: Dubai & Abu Dhabi",
    nights: 8,
    price: 1299,
    description:
      "Plunge into the supreme opulence of the United Arab Emirates. From Dubai's modern skyscrapers to Abu Dhabi's cultural gems, enjoy an excellent fusion of contemporary luxury and classic Arabian welcome.",
    highlights: [
      "Observation platform at Burj Khalifa",
      "Desert adventure with dune driving",
      "See the majestic Sheikh Zayed Mosque",
      "Premium yacht trip around Dubai Marina",
      "Shop at luxury centers and old souks",
      "View the spectacular Dubai Fountain",
      "Explore the impressive Louvre Abu Dhabi",
    ],
    facts: [
      { icon: <FaClock />, label: "Time Zone", value: "GMT+4" },
      {
        icon: <FaPlane />,
        label: "Approximate Flight Duration",
        value: "7 hours",
      },
      {
        icon: <FaPassport />,
        label: "Visa Needed",
        value: "Yes (Arrival Visa)",
      },
      { icon: <FaCity />, label: "Capital", value: "Abu Dhabi" },
      { icon: <FaUsers />, label: "Inhabitants", value: "9.9 million" },
      { icon: <FaMoneyBillAlt />, label: "Money", value: "UAE Dirham" },
    ],
  },
  {
    id: "maldives",
    image: "/maldives.webp",
    location: "Maldives: Indian Ocean Haven",
    nights: 10,
    price: 1999,
    description:
      "Enjoy the absolute tropical haven in the Maldives. Treat yourself to premium overwater bungalows, perfect white sand coasts, and among the planet's most amazing sea creatures. An ideal retreat for those desiring complete calm and ocean exploration.",
    highlights: [
      "Accommodation in premium overwater suite",
      "Snorkel and dive in transparent waters",
      "Exclusive evening boat journey",
      "Sea creature discovery and reef excursions",
      "Spa therapies overlooking the ocean",
      "Eat at submarine dining venues",
      "Swim alongside manta rays and whale sharks",
    ],
    facts: [
      { icon: <FaClock />, label: "Time Zone", value: "GMT+5" },
      {
        icon: <FaPlane />,
        label: "Approximate Flight Duration",
        value: "10 hours",
      },
      { icon: <FaPassport />, label: "Visa Needed", value: "Arrival Visa" },
      { icon: <FaCity />, label: "Capital", value: "Malé" },
      { icon: <FaUsers />, label: "Inhabitants", value: "540k" },
      { icon: <FaMoneyBillAlt />, label: "Money", value: "Maldivian Rufiyaa" },
    ],
  },
  {
    id: "thailand",
    image: "/bankok.avif",
    location: "Thailand: Culture & Islands",
    nights: 12,
    price: 1199,
    description:
      "Reveal the wonder of Thailand, from dynamic Bangkok to the perfect isles of Phuket and Krabi. Encounter an excellent combination of energetic urban living, deep cultural legacy, and tropical haven beaches with amazing nightlife.",
    highlights: [
      "Tour Bangkok's Royal Palace",
      "Island tours around Phuket and Krabi",
      "Authentic Thai culinary workshop",
      "Snorkeling in transparent seas",
      "Explore regional bazaars and food stalls",
      "See age-old temples in Chiang Mai",
      "Join the renowned Full Moon Celebration",
    ],
    facts: [
      { icon: <FaClock />, label: "Time Zone", value: "GMT+7" },
      {
        icon: <FaPlane />,
        label: "Approximate Flight Duration",
        value: "11 hours",
      },
      { icon: <FaPassport />, label: "Visa Needed", value: "Arrival Visa" },
      { icon: <FaCity />, label: "Capital", value: "Bangkok" },
      { icon: <FaUsers />, label: "Inhabitants", value: "69.8 million" },
      { icon: <FaMoneyBillAlt />, label: "Money", value: "Thai Baht" },
    ],
  },
  {
    id: "indonesia",
    image: "/indonesia.webp",
    location: "Indonesia: Beyond Bali",
    nights: 10,
    price: 1299,
    description:
      "Engage with the splendor of Indonesia, concentrating on Bali's spiritual scenery, lively culture, and amazing natural charm. Experience a voyage of revelation across green scenery, old temples, and untouched beaches.",
    highlights: [
      "Tour Ubud's rice field landscapes",
      "See famous temples including Uluwatu",
      "Classic Balinese dance shows",
      "Health and spa sessions",
      "Surfing classes and coast relaxation",
      "Dawn climb on Mount Batur volcano",
      "Visit Ubud's holy Monkey Sanctuary",
    ],
    facts: [
      { icon: <FaClock />, label: "Time Zone", value: "GMT+8" },
      {
        icon: <FaPlane />,
        label: "Approximate Flight Duration",
        value: "15 hours",
      },
      { icon: <FaPassport />, label: "Visa Needed", value: "Arrival Visa" },
      { icon: <FaCity />, label: "Capital", value: "Jakarta" },
      { icon: <FaUsers />, label: "Inhabitants", value: "273 million" },
      { icon: <FaMoneyBillAlt />, label: "Money", value: "Indonesian Rupiah" },
    ],
  },
  {
    id: "malaysia",
    image: "/malasiya.webp",
    location: "Malaysia: Traditional & Modern",
    nights: 9,
    price: 1099,
    description:
      "Encounter the special fusion of tradition and modernity in Malaysia. From the advanced Kuala Lumpur to the old Penang and perfect beaches of Langkawi, find a varied and energetic location with wonderful nightlife.",
    highlights: [
      "Tour Kuala Lumpur's Petronas Towers",
      "See the historic town of George Town",
      "Find the Cameron Highlands area",
      "Sample Malaysian street cuisine",
      "Rest on Langkawi's lovely shores",
      "Explore the Batu Caves shrine complex",
      "Visit the historical city of Malacca",
    ],
    facts: [
      { icon: <FaClock />, label: "Time Zone", value: "GMT+8" },
      {
        icon: <FaPlane />,
        label: "Approximate Flight Duration",
        value: "9 hours",
      },
      {
        icon: <FaPassport />,
        label: "Visa Needed",
        value: "No (for numerous visitors)",
      },
      { icon: <FaCity />, label: "Capital", value: "Kuala Lumpur" },
      { icon: <FaUsers />, label: "Inhabitants", value: "32 million" },
      { icon: <FaMoneyBillAlt />, label: "Money", value: "Malaysian Ringgit" },
    ],
  },
  {
    id: "india",
    image: "/india.webp",
    location: "India: Contrasts & Colors",
    nights: 14,
    price: 1499,
    description:
      "Start a phenomenal voyage across India's varied geography and deep cultural legacy. From the famous Taj Mahal to energetic cities and peaceful backwaters, encounter a nation of remarkable variety.",
    highlights: [
      "Tour the Taj Mahal in Agra",
      "Explore the rose-colored city of Jaipur",
      "Experience Kerala's backwater system",
      "Find spiritual Varanasi city",
      "Sample genuine Indian dishes",
      "Wildlife tour in Ranthambore Park",
      "Visit Amritsar's Golden Temple",
    ],
    facts: [
      { icon: <FaClock />, label: "Time Zone", value: "GMT+5:30" },
      {
        icon: <FaPlane />,
        label: "Approximate Flight Duration",
        value: "8 hours",
      },
      { icon: <FaPassport />, label: "Visa Needed", value: "Yes" },
      { icon: <FaCity />, label: "Capital", value: "New Delhi" },
      { icon: <FaUsers />, label: "Inhabitants", value: "1.4 billion" },
      { icon: <FaMoneyBillAlt />, label: "Money", value: "Indian Rupee" },
    ],
  },
  {
    id: "srilanka",
    image: "/srilanka.webp",
    location: "Sri Lanka: Treasure Island",
    nights: 8,
    price: 999,
    description:
      "Unearth the tropical haven of Sri Lanka, featuring its old remains, green tea fields, animal parks, and perfect beaches. An ideal location for nature fans and culture lovers with ancient historical sites.",
    highlights: [
      "Investigate old Sigiriya Rock Castle",
      "Animal tour in Yala National Park",
      "Tea farm visit in Nuwara Eliya",
      "Rest on gorgeous southern coasts",
      "Tour sacred Buddhist shrines",
      "Picturesque railway journey through highlands",
      "See Kandy's Temple of the Tooth",
    ],
    facts: [
      { icon: <FaClock />, label: "Time Zone", value: "GMT+5:30" },
      {
        icon: <FaPlane />,
        label: "Approximate Flight Duration",
        value: "7 hours",
      },
      { icon: <FaPassport />, label: "Visa Needed", value: "Yes (ETA)" },
      { icon: <FaCity />, label: "Capital", value: "Colombo" },
      { icon: <FaUsers />, label: "Inhabitants", value: "22 million" },
      { icon: <FaMoneyBillAlt />, label: "Money", value: "Sri Lankan Rupee" },
    ],
  },
  {
    id: "southafrica",
    image: "/southafrica.webp",
    location: "South Africa: Wonders & Wildlife",
    nights: 12,
    price: 1799,
    description:
      "Encounter the amazing variety of South Africa, from Cape Town's spectacular scenery to globally famous animal reserves. A voyage of stunning natural splendor, wildlife meetings, and deep cultural encounters.",
    highlights: [
      "Safari trip in Kruger Park",
      "Tour Cape Town and Table Mountain",
      "Wine sampling in Stellenbosch region",
      "Visit Robben Island site",
      "Whale observation in Hermanus town",
      "Travel the beautiful Garden Route road",
      "See the Cape of Good Hope point",
    ],
    facts: [
      { icon: <FaClock />, label: "Time Zone", value: "GMT+2" },
      {
        icon: <FaPlane />,
        label: "Approximate Flight Duration",
        value: "11 hours",
      },
      {
        icon: <FaPassport />,
        label: "Visa Needed",
        value: "No (for many visitors)",
      },
      {
        icon: <FaCity />,
        label: "Capital Cities",
        value: "Pretoria, Cape Town, Bloemfontein",
      },
      { icon: <FaUsers />, label: "Inhabitants", value: "59 million" },
      { icon: <FaMoneyBillAlt />, label: "Money", value: "South African Rand" },
    ],
  },
  {
    id: "japan",
    image: "/japan.webp",
    location: "Japan: Culture & Cherry Blossoms",
    nights: 10,
    price: 1999,
    description:
      "Engage with the deep traditions and futuristic urban centers of Japan, from the amazing cherry blossoms in Kyoto to the dynamic vitality of Tokyo. A voyage of cultural inheritance, natural splendor, and modern marvels.",
    highlights: [
      "Observe cherry blooms in Kyoto",
      "Investigate the busy roads of Tokyo",
      "Tour ancient temples in Nara area",
      "Join a classic tea ritual",
      "Unwind in a Hakone thermal spring",
      "Travel on the famous bullet train",
      "Visit Kyoto's Fushimi Inari Shrine",
    ],
    facts: [
      { icon: <FaClock />, label: "Time Zone", value: "GMT+9" },
      {
        icon: <FaPlane />,
        label: "Approximate Flight Duration",
        value: "13 hours",
      },
      {
        icon: <FaPassport />,
        label: "Visa Needed",
        value: "Yes (for most visitors)",
      },
      { icon: <FaCity />, label: "Capital", value: "Tokyo" },
      { icon: <FaUsers />, label: "Inhabitants", value: "126 million" },
      { icon: <FaMoneyBillAlt />, label: "Money", value: "Japanese Yen" },
    ],
  },
  {
    id: "greece",
    image: "/greece.webp",
    location: "Greece: Ancient Wonders & Islands",
    nights: 9,
    price: 1599,
    description:
      "Reveal the stunning charm of Greece, from the sun-drenched isles of Santorini to the historical remains of Athens. A voyage of clear blue seas, ancient monuments, and rich Mediterranean tastes. An ideal spot for historical visits and relaxation.",
    highlights: [
      "Tour Athens' Acropolis hill",
      "Sail among the Cyclades isles",
      "View the evening sky in Santorini",
      "See the monasteries at Meteora",
      "Sample real Greek dishes",
      "Swim in the clear seas of Mykonos",
      "Investigate the old ruins of Delphi",
    ],
    facts: [
      { icon: <FaClock />, label: "Time Zone", value: "GMT+2" },
      {
        icon: <FaPlane />,
        label: "Approximate Flight Duration",
        value: "4 hours",
      },
      {
        icon: <FaPassport />,
        label: "Visa Needed",
        value: "No (for EU & many visitors)",
      },
      { icon: <FaCity />, label: "Capital", value: "Athens" },
      { icon: <FaUsers />, label: "Inhabitants", value: "10.4 million" },
      { icon: <FaMoneyBillAlt />, label: "Money", value: "Euro" },
    ],
  },
];

const DestinationDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [expandedSections, setExpandedSections] = useState({});
  const [selectedClass, setSelectedClass] = useState("Economy");
  const [selectedYear, setSelectedYear] = useState("2025");

  const destination = destinations.find((dest) => dest.id === id);

  if (!destination) {
    return (
      <div className="dest-error-container">
        <h1 className="dest-error-title">Destination Not Found</h1>
        <Link to="/" className="dest-error-btn">
          Browse Destinations
        </Link>
      </div>
    );
  }

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  // Dummy data structure
  const priceData = {
    Economy: {
      2025: [
        {
          month: "November",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2099 pp",
        },
        {
          month: "December",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2099 pp",
        },
      ],
      2026: [
        {
          month: "January",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2399 pp",
        },
        {
          month: "February",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2399 pp",
        },
        {
          month: "March",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2399 pp",
        },
        {
          month: "April",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2499 pp",
        },
        {
          month: "May",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2399 pp",
        },
        {
          month: "June",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2399 pp",
        },
        {
          month: "July",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2699 pp",
        },
        {
          month: "August",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2899 pp",
        },
        {
          month: "September",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2649 pp",
        },
        {
          month: "October",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2599 pp",
        },
        {
          month: "November",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2399 pp",
        },
        {
          month: "December",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2599 pp",
        },
      ],
      2027: [
        {
          month: "January",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2449 pp",
        },
        {
          month: "February",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2649 pp",
        },
        {
          month: "March",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2599 pp",
        },
        {
          month: "April",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2699 pp",
        },
        {
          month: "May",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2699 pp",
        },
        {
          month: "June",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2649 pp",
        },
        {
          month: "July",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2899 pp",
        },
        {
          month: "August",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£3149 pp",
        },
        {
          month: "September",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2949 pp",
        },
        {
          month: "October",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2849 pp",
        },
        {
          month: "November",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2649 pp",
        },
        {
          month: "December",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£2849 pp",
        },
      ],
    },
    Business: {
      2025: [
        {
          month: "November",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£3549 pp",
        },
        {
          month: "December",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£3549 pp",
        },
      ],
      2026: [
        {
          month: "January",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£3799 pp",
        },
        {
          month: "February",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£3799 pp",
        },
        {
          month: "March",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£3799 pp",
        },
        {
          month: "April",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£3799 pp",
        },
        {
          month: "May",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£3799 pp",
        },
        {
          month: "June",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£3799 pp",
        },
        {
          month: "July",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£3999 pp",
        },
        {
          month: "August",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£3999 pp",
        },
        {
          month: "September",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£3999 pp",
        },
        {
          month: "October",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£3999 pp",
        },
        {
          month: "November",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£3949 pp",
        },
        {
          month: "December",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£4149 pp",
        },
      ],
      2027: [
        {
          month: "January",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£4099 pp",
        },
        {
          month: "February",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£4099 pp",
        },
        {
          month: "March",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£4099 pp",
        },
        {
          month: "April",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£4149 pp",
        },
        {
          month: "May",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£4149 pp",
        },
        {
          month: "June",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£4149 pp",
        },
        {
          month: "July",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£4399 pp",
        },
        {
          month: "August",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£4399 pp",
        },
        {
          month: "September",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£4399 pp",
        },
        {
          month: "October",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£4399 pp",
        },
        {
          month: "November",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£4299 pp",
        },
        {
          month: "December",
          boardBasis: "Full Board",
          nights: "5 Nights",
          price: "£4549 pp",
        },
      ],
    },
  };

  const handleCallClick = () => {
    window.location.href = "tel:02033557350  ";
  };
  return (
    <div className="dest-page-wrapper">
      {/* Hero Banner */}
      <div className="dest-hero-banner">
        <div className="dest-hero-image-container">
          <img
            src={destination.image}
            alt={destination.location}
            className="dest-hero-image"
          />
          <div className="dest-hero-gradient"></div>
        </div>

        <div className="dest-hero-content">
          <h1 className="dest-hero-title">
            <span className="dest-title-line-1">{destination.location}</span>
            <span className="dest-title-line-2">
              {destination.nights} Nights Luxury Escape
            </span>
          </h1>

          <div className="dest-hero-stats">
            <div className="dest-stat-item">
              <FaCalendarAlt className="dest-stat-icon" />
              <div>
                <span className="dest-stat-value">{destination.nights}</span>
                <span className="dest-stat-label">Nights</span>
              </div>
            </div>
            {/*--
            <div className="dest-stat-item">
              <FaMoneyBillAlt className="dest-stat-icon" />
              <div>
                <span className="dest-stat-value">£{destination.price}</span>
                <span className="dest-stat-label">From</span>
              </div>
            </div>
            --*/}
            <div className="dest-stat-item">
              <FaUmbrellaBeach className="dest-stat-icon" />
              <div>
                <span className="dest-stat-value">5.0</span>
                <span className="dest-stat-label">Rating</span>
              </div>
            </div>
          </div>

          <div className="dest-hero-cta">
            <button
              className="dest-primary-cta"
              onClick={() => navigate("/contactus#form-c")}
            >
              <span>Enquire Now</span>
              <FaArrowRight />
            </button>

            <button
              className="dest-secondary-cta"
              onClick={() =>
                document.getElementById("prices-check")?.scrollIntoView({
                  behavior: "smooth",
                })
              }
            >
              <span>Check Now</span>
            </button>
          </div>
        </div>
      </div>
      <Deal showHeader={false} />
      {/* Main Content with Sidebar */}
      <div className="dest-content-container">
        <div className="dest-main-content-main">
          <div className="dest-main-content">
            {/* About Section */}
            <section className="dest-section">
              <div className="dest-section-header">
                <h2 className="dest-section-title">
                  <span className="dest-title-number">01</span>
                  <span className="dest-title-text">About This Experience</span>
                </h2>
                <div className="dest-title-line"></div>
              </div>

              <div className="dest-about-grid">
                <div className="dest-about-card">
                  <div id="prices-check" className="dest-card-header">
                    <h3 className="dest-card-title">Journey Overview</h3>
                    <div className="dest-card-decoration"></div>
                  </div>
                  <p className="dest-description">{destination.description}</p>
                  {/*-- <div className="dest-price-tag">
                  <span className="dest-price-amount">£{destination.price}</span>
                  <span className="dest-price-note">per person</span>
                </div>
                --*/}
                </div>

                <div className="dest-about-card dest-highlights-card">
                  <div className="dest-card-header">
                    <h3 className="dest-card-title">Signature Experiences</h3>
                    <div className="dest-card-decoration"></div>
                  </div>
                  <div className="dest-highlights-list">
                    {destination.highlights.map((item, index) => (
                      <div key={index} className="dest-highlight-item">
                        <div className="dest-highlight-number">{index + 1}</div>
                        <div className="dest-highlight-content">
                          <span className="dest-highlight-text">{item}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>

            {/* Facts Section */}
            <section className="dest-section">
              <div className="dest-section-header">
                <h2 className="dest-section-title">
                  <span className="dest-title-number">02</span>
                  <span className="dest-title-text">Destination Insights</span>
                </h2>
                <div className="dest-title-line"></div>
              </div>

              <div className="dest-facts-grid">
                {destination.facts.map((fact, index) => (
                  <div key={index} className="dest-fact-card">
                    <div className="dest-fact-icon-wrapper">{fact.icon}</div>
                    <div className="dest-fact-content">
                      <h4 className="dest-fact-label">{fact.label}</h4>
                      <p className="dest-fact-value">{fact.value}</p>
                    </div>
                    <div className="dest-fact-glow"></div>
                  </div>
                ))}
              </div>
            </section>

            {/* Kenya Safari Sections */}
            {id === "kenya-safari" && (
              <>
                {/* Itinerary */}
                <section className="dest-section">
                  <div
                    className="dest-section-header dest-expandable"
                    onClick={() => toggleSection("itinerary")}
                  >
                    <h2 className="dest-section-title">
                      <span className="dest-title-number">03</span>
                      <span className="dest-title-text">
                        Detailed Itinerary
                      </span>
                    </h2>
                    <div className="dest-expand-icon">
                      {expandedSections.itinerary ? (
                        <FaChevronUp />
                      ) : (
                        <FaChevronDown />
                      )}
                    </div>
                  </div>

                  {expandedSections.itinerary && (
                    <div className="dest-itinerary-timeline">
                      {[1, 2, 3, 4, 5, 6].map((day) => (
                        <div key={day} className="dest-timeline-item">
                          <div className="dest-timeline-marker">
                            <div className="dest-timeline-dot"></div>
                            <div className="dest-timeline-line"></div>
                          </div>
                          <div className="dest-timeline-content">
                            <div className="dest-timeline-header">
                              <span className="dest-timeline-day">
                                DAY {day}
                              </span>
                              <span className="dest-timeline-title">
                                Safari Adventure Day
                              </span>
                            </div>
                            <p className="dest-timeline-description">
                              Experience the wild beauty of Kenya with game
                              drives, cultural visits, and luxury
                              accommodations.
                            </p>
                            <div className="dest-timeline-image">
                              <img
                                src={`/kenya${day}.webp`}
                                alt={`Day ${day}`}
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </section>

                {/* Accommodation */}
                <section className="dest-section">
                  <div
                    className="dest-section-header dest-expandable"
                    onClick={() => toggleSection("accommodation")}
                  >
                    <h2 className="dest-section-title">
                      <span className="dest-title-number">04</span>
                      <span className="dest-title-text">
                        Luxury Accommodation
                      </span>
                    </h2>
                    <div className="dest-expand-icon">
                      {expandedSections.accommodation ? (
                        <FaChevronUp />
                      ) : (
                        <FaChevronDown />
                      )}
                    </div>
                  </div>

                  {expandedSections.accommodation && (
                    <div className="dest-accommodation-grid">
                      {[1, 2, 3].map((hotel) => (
                        <div key={hotel} className="dest-hotel-card">
                          <div className="dest-hotel-image">
                            <img
                              src={`/kenyahotel${hotel}.webp`}
                              alt={`Hotel ${hotel}`}
                            />
                            <div className="dest-hotel-badge">Luxury Lodge</div>
                          </div>
                          <div className="dest-hotel-content">
                            <h3 className="dest-hotel-name">
                              Safari Lodge Resort
                            </h3>
                            <div className="dest-hotel-rating">
                              {[...Array(5)].map((_, i) => (
                                <FaStar key={i} className="dest-star" />
                              ))}
                              <span className="dest-rating-text">
                                5.0 Excellence
                              </span>
                            </div>
                            <div className="dest-hotel-amenities">
                              <span className="dest-amenity">
                                <FaSwimmingPool /> Pool
                              </span>
                              <span className="dest-amenity">
                                <FaWifi /> WiFi
                              </span>
                              <span className="dest-amenity">
                                <FaUtensils /> Dining
                              </span>
                              <span className="dest-amenity">
                                <FaCar /> Safari
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </section>

                {/* Pricing */}
                <section className="dest-section">
                  <div className="dest-section-header">
                    <h2 className="dest-section-title">
                      <span className="dest-title-number">05</span>
                      <span className="dest-title-text">
                        Pricing & Availability
                      </span>
                    </h2>
                    <div className="dest-title-line"></div>
                  </div>

                  <div className="dest-pricing-container">
                    <div className="dest-pricing-controls">
                      <div className="dest-class-toggle">
                        <button
                          className={`dest-toggle-btn ${selectedClass === "Economy" ? "active" : ""}`}
                          onClick={() => setSelectedClass("Economy")}
                        >
                          <span>Economy</span>
                          <span className="dest-toggle-badge">
                            Most Popular
                          </span>
                        </button>
                        <button
                          className={`dest-toggle-btn ${selectedClass === "Business" ? "active" : ""}`}
                          onClick={() => setSelectedClass("Business")}
                        >
                          <span>Business</span>
                          <span className="dest-toggle-badge">Premium</span>
                        </button>
                      </div>

                      <div className="dest-year-toggle">
                        {["2025", "2026", "2027"].map((year) => (
                          <button
                            key={year}
                            className={`dest-year-btn ${selectedYear === year ? "active" : ""}`}
                            onClick={() => setSelectedYear(year)}
                          >
                            {year}
                          </button>
                        ))}
                      </div>
                    </div>

                    <div className="dest-price-table">
                      <div className="dest-table-header">
                        <div>Month</div>
                        <div>Board</div>
                        <div>Duration</div>
                        <div>Price</div>
                        <div>Action</div>
                      </div>
                      <div className="dest-table-body">
                        {priceData[selectedClass][selectedYear].map(
                          (row, index) => (
                            <div key={index} className="dest-table-row">
                              <div className="dest-month-cell">{row.month}</div>
                              <div>{row.boardBasis}</div>
                              <div>{row.nights}</div>
                              <div className="dest-price-cell">
                                £{row.price}
                              </div>
                              <div>
                                <button className="dest-book-btn">
                                  <span>Enquire</span>
                                  <FaArrowRight />
                                </button>
                              </div>
                            </div>
                          ),
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              </>
            )}
          </div>
        </div>

        {/* Sticky Sidebar */}
        <div className="dest-sidebar">
          <div className="dest-sidebar-sticky">
            <div className="dest-sidebar-header">
              <h3 className="dest-sidebar-title">
                <FaMapMarkerAlt className="dest-sidebar-icon" />
                <span>Explore More</span>
              </h3>
              <div className="dest-sidebar-count">
                {destinations.length}+ Destinations
              </div>
            </div>

            <div className="dest-sidebar-list">
              {destinations.map((dest) => (
                <div
                  key={dest.id}
                  className={`dest-sidebar-item ${dest.id === id ? "active" : ""}`}
                  onClick={() => navigate(`/holidays/${dest.id}`)}
                >
                  <div className="dest-sidebar-image">
                    <img src={dest.image} alt={dest.location} />
                    {dest.id === id && (
                      <div className="dest-current-badge">Viewing</div>
                    )}
                  </div>
                  <div className="dest-sidebar-content">
                    <h4 className="dest-sidebar-name">{dest.location}</h4>
                    <div className="dest-sidebar-meta">
                      <span className="dest-sidebar-nights">
                        {dest.nights} Nights
                      </span>
                      {/*---<span className="dest-sidebar-price">£{dest.price}</span>--*/}
                    </div>
                    <div className="dest-sidebar-rating">
                      {[...Array(5)].map((_, i) => (
                        <FaStar key={i} className="dest-sidebar-star" />
                      ))}
                    </div>
                  </div>
                  <div className="dest-sidebar-arrow">
                    <FaArrowRight />
                  </div>
                </div>
              ))}
            </div>

            <div className="dest-sidebar-cta">
              <h4 className="dest-cta-title">Need Assistance?</h4>
              <p className="dest-cta-text">
                Our travel experts are here to help
              </p>
              <button className="dest-cta-button" onClick={handleCallClick}>
                <span>Contact Specialist</span>
                <FaArrowRight />
              </button>
            </div>
          </div>
        </div>
      </div>

      <WhyChoose />
    </div>
  );
};

export default DestinationDetails;
